module.exports = __webpack_public_path__ + "img/social-media.efe28453.svg";